<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
  <v-row v-if="device.data.properties.iaq !== undefined" class="whitesmoke py-4" no-gutters>
    <DeviceOverviewSliderCard
      v-if="device.data.properties.iaq.bme_t_off !== undefined"
      :value="device.data.properties.iaq.bme_t_off"
      :title_number="$t('temperature_offset')"
      text_font_size="18px"
      control="iaq_set_offset"
      @setIAQTemperatureOffset="setIAQTemperatureOffset"
      :min=0
      :max=10
      :disabled=false
    >
    </DeviceOverviewSliderCard>
  </v-row>
</template>


<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TimeUtil } from '@/helpers/TimeUtil'
import DashboardCardBarChart from "@/components/Cards/DashboardCardBarChart.vue";
import DashboardCardPieChart from "@/components/Cards/DashboardCardPieChart.vue";
import DeviceOverviewCard from "@/components/Cards/DeviceOverviewCard.vue";
import DeviceOverviewSwitchCard from "@/components/Cards/DeviceOverviewSwitchCard.vue";
import DeviceOverviewButtonCard from "@/components/Cards/DeviceOverviewButtonCard.vue";
import DeviceOverviewHeatingBalanceSliderCard from "@/components/Cards/DeviceOverviewHeatingBalanceSliderCard.vue";
import DeviceOverviewSliderCard from "@/components/Cards/DeviceOverviewSliderCard.vue";
import DashboardCardFaultsPieChart from "@/components/Cards/DashboardCardFaultsPieChart.vue";
import DeviceOverviewRoomTargetCard from "@/components/Cards/DeviceOverviewRoomTargetCard.vue";
import { devicesModule } from '@/store/modules/store-accessor'

@Component({
  components: {
    DashboardCardBarChart,
    DashboardCardPieChart,
    DeviceOverviewCard,
    DeviceOverviewSwitchCard,
    DeviceOverviewButtonCard,
    DeviceOverviewHeatingBalanceSliderCard,
    DeviceOverviewSliderCard,
    DeviceOverviewRoomTargetCard,
    DashboardCardFaultsPieChart,
  }
})

export default class IAQControlView extends Vue {
  @Prop() device: Record<string, any>;


  formatDate (date: Date): string {
    return TimeUtil.formatDateTime(date)
  }

  setIAQTemperatureOffset(val: string): void {
    let data = {
        action: "bme_t_r_offset",
        action_value: val,
    }
    devicesModule.updateDeviceConfig(data);
  }
};
</script>

<style scoped lang="scss">
.tab {
  max-height: calc(80vh - 230px) !important;
  overflow-y: auto;
}

div { 
    width:100%;
}
</style>
